import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileGif"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 9V15C1.5 16.2426 2.50736 17.25 3.75 17.25H7.5V11.25H4.5V12.75H6V15.75H3.75C3.33579 15.75 3 15.4142 3 15V9C3 8.58579 3.33579 8.25 3.75 8.25H7.5V6.75H3.75C2.50736 6.75 1.5 7.75736 1.5 9ZM22.5 8.25V6.75H16.5V17.25H18V12.75H21.75V11.25H18V8.25H22.5ZM9 6.75V8.25H11.25V15.75H9V17.25H15V15.75H12.75V8.25H15V6.75H9Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileGif.vue"]]);
